import { SVGProps, Ref, forwardRef } from 'react'
const SvgSearch = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14.624 9.958a4.667 4.667 0 1 1-9.333 0 4.667 4.667 0 0 1 9.333 0Z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m13.258 13.258 5.45 5.45"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgSearch)
export default ForwardRef
